import React from 'react'
import type { SelectProps, SelectOption } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import { CustomerType } from '@ztechapps/customer.common'
import map from 'lodash/map'
import find from 'lodash/find'

const customerTypeOptions: SelectOption[] = map(CustomerType, (item) => {
  return { value: item?.value, label: item?.value }
})

export const CustomerTypeSelect = ({ value, ...rest }: SelectProps) => {
  const objValue = find(customerTypeOptions, { value }) as SelectOption

  return (
    <Select
      {...{
        ...rest,
        value: objValue,
        options: customerTypeOptions,
      }}
    />
  )
}
